module.exports = "<div fxLayout=\"row\" fxLayoutAlign=\"center\">\r\n    <div fxFlex fxLayout=\"column\" fxLayoutAlign=\"space-between\">\r\n        <div>\r\n            <img src=\"assets/images/people-32.png\" />\r\n            <label class=\"title\">משתמשים</label>\r\n        </div>\r\n        <div fxLayout=\"column\" fxLayoutAlign=\"start center\" fxFlex=\"95\" fxFlex.xs=\"100\">\r\n            <app-users-grid></app-users-grid>\r\n        </div>\r\n    </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/users/users-page/users-page.component.html
// module id = ./src/app/components/users/users-page/users-page.component.html
// module chunks = main